export enum CardVariant {
  SERVICE = "SERVICE",
  BOOKING = "BOOKING",
}